// Hijos de la familia por ciclo escolar: carga el historial de inscripciones una vez
// y filtra por el ciclo elegido (inicia en el ciclo académico, que cambia en enero).
import { useState, useEffect } from 'react';
import { message } from 'antd';
import apiClient from '../../../api/apiClient';
import { ciclosDeInscripciones, cicloInicial } from '../../../utils/cicloEscolar';

const useHijosPorCiclo = () => {
  const [inscripciones, setInscripciones] = useState([]);
  const [idFamilia, setIdFamilia] = useState(null);
  const [ciclo, setCiclo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cargar = async () => {
      setLoading(true);
      try {
        const perfilResponse = await apiClient.get('/login/perfil');
        const IdFamilia = perfilResponse.data.data.IdFamilia;

        if (!IdFamilia) {
          message.error('No se pudo obtener la información de la familia');
          return;
        }

        // Sin cicloEscolar el endpoint devuelve todas las inscripciones activas (historial)
        const response = await apiClient.get(`/familias/hijosporfamilia/${IdFamilia}`);
        const todas = response.data.success ? response.data.data || [] : [];

        setIdFamilia(IdFamilia);
        setInscripciones(todas);
        setCiclo(cicloInicial(ciclosDeInscripciones(todas)) || null);
      } catch (error) {
        if (error.response?.status === 404) {
          message.info('No se encontraron hijos inscritos');
        } else {
          message.error('Error al cargar la información de los hijos');
        }
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, []);

  const ciclos = ciclosDeInscripciones(inscripciones);
  const hijos = inscripciones.filter(i => String(i.CicloEscolar) === ciclo);

  return { idFamilia, ciclos, ciclo, setCiclo, hijos, loading };
};

export default useHijosPorCiclo;
